export const ProductOverviewResponse = {

  relationRestrictedDataView: '',
  relationMarketSegmentCode: '',
  restrictedDataViewException: '',
  perspective: '',
};
